module.exports = __webpack_public_path__ + "img/logo.cb849485.png";